<template>
  <h1 class="text-center">Queues are empty</h1>
</template>

<script>
  export default {
    name: 'QueuesEmpty',
  };
</script>
